<template id="forgotPassword">
  <div class="container float-page">
    <!-- Float Box -->
    <div class="float-box">
      <div class="card">
        <!-- Float Card Body -->
        <div class="card-body float-card-body">
          <h1 class="mb-3">{{ $t('Customer.forgotPassword.Forgot_password') }}</h1>
          <p class="float-box-msg mb-2">
            {{ $t('Customer.forgotPassword.email') }}<br />
            {{ $t('Customer.forgotPassword.link') }}<br />
            {{ $t('Customer.forgotPassword.mailbox') }}
          </p>
          <el-form :model="forgotModel" :rules="forgotRules" ref="forgotForm">
            <el-form-item prop="emailOrName">
              <el-input
                v-model="forgotModel.emailOrName"
                :placeholder="$t('Customer.forgotPassword.Electronic_mail')"
                suffix-icon="fas fa-envelope fa-sm"
              ></el-input>
            </el-form-item>
          </el-form>

          <el-button
            type="primary"
            plain
            @click="sendEmail('forgotForm')"
            :disabled="disable"
            class="btn btn-block btn-primary btn-lg email--send---success"
          >
            {{ this.btntext }}
          </el-button>
          <p class="text-center mt-5">
            {{ $t('Customer.forgotPassword.please') }}<a
              href="mailto:info@soonnet.org?subject=重設密碼時遇上問題&body=請說明您的問題，並留下會員名稱或登記電子郵件："
              class="text-center"
              >{{ $t('Customer.forgotPassword.contact_us') }}</a
            >
          </p>
        </div>
        <!-- /.float-card-body -->
      </div>
    </div>
    <!-- /.float box -->
  </div>
</template>
<script>
import { Message } from "element-ui";
export default {
  data() {
    /* 是否邮箱*/
    var isEmail = (rule, value, callback) => {
      console.log(1111);
      const reg = /^([a-zA-Z0-9]+[-_\.]?)+@[a-zA-Z0-9]+\.[a-z]+$/;
      if (value == "" || value == undefined || value == null) {
        callback(new Error(this.$t('Customer.forgotPassword.registerEmailRules.error1')));
      } else {
        if (value.indexOf("@") === -1) {
          callback(new Error(this.$t('Customer.forgotPassword.registerEmailRules.error2')));
        } else {
          callback();
        }
      }
    };
    return {
      btntext: this.$t('Customer.forgotPassword.btntext.title1'),
      count: 60,
      disable: false,
      forgotModel: {
        emailOrName: "",
      },
      forgotRules: {
        emailOrName: [{ validator: isEmail, trigger: "blur" }],
      },
    };
  },
  created() {
    this.$store.dispatch("updateCurrentIndex", 0);
  },
  methods: {
    sendEmail(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          //發送密碼重置至郵箱
          let params = {
            email: this.forgotModel.emailOrName,
          };
          // this.submitTips();
          this.$api.common.resetPass(params).then((res) => {
            if (res.data.success) {
              //提示發送成功
              Message({ type: "success", message: "發送成功" });
              this.setnumber();
              this.submitTips();
            } else {
              Message({ type: "error", message: "未找到對應的郵箱賬戶" });
            }
          });
        }
      });
      // this.$router.push({name:'resetPassword'})
    },
    setnumber() {
      var countDown = setInterval(() => {
        if (this.count < 1) {
          this.disable = false;
          this.btntext = this.$t('Customer.forgotPassword.btntext.title1');
          this.count = 60;
          clearInterval(countDown);
        } else {
          this.disable = true;
          this.btntext = this.count-- +''+ this.$t('Customer.forgotPassword.btntext.title2');
        }
      }, 1000);
    },
    submitTips() {
      // this.$notify({
      //   title: "",
      //   message: "重設密碼電郵已發送至" + this.forgotModel.emailOrName + "郵箱",
      //   position: "bottom-right",
      //   type: "success",
      //   duration: 0
      // });
      //  this.$alert("重設密碼電郵已發送至" + this.forgotModel.emailOrName + "郵箱", '', {
      //   confirmButtonText: '确定',
      //   callback: action => {
      //     this.$message({
      //       type: 'info',
      //       message: `action: ${action}`
      //     });
      //   }
      // });
       this.$confirm("重設密碼電郵已發送至" + this.forgotModel.emailOrName + "郵箱", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success',
        center: true
      }).then(() => {
      }).catch(() => {
      });
    },
  },
};
</script>


// WEBPACK FOOTER //
// src/components/Customer/forgotPassword.vue